import Vue from 'vue'
import Router from 'vue-router'
const Hello = () => import(/* webpackChunkName: "static" */ '@/components/Hello')
// import Hello from '@/components/Hello'
const Suscripcion = () => import(/* webpackChunkName: "static" */ '@/components/static/Suscripcion')
// import Suscripcion from '@/components/static/Suscripcion'
const Login = () => import(/* webpackChunkName: "static" */ '@/components/static/Login')
// import Login from '@/components/static/Login'
// const Logout = () => import(/* webpackChunkName: "static" */ '@/components/static/Logout')
import Logout from '@/components/static/Logout'
// const Registro = () => import(/* webpackChunkName: "static" */ '@/components/static/Registro')
import Registro from '@/components/static/Registro'
// const Recuperar = () => import(/* webpackChunkName: "static" */ '@/components/static/Recuperar')
import Recuperar from '@/components/static/Recuperar'
// const Contacto = () => import(/* webpackChunkName: "static" */ '@/components/static/Contacto')
import Contacto from '@/components/static/Contacto'
// const Faq = () => import(/* webpackChunkName: "static" */ '@/components/static/Faq')
import Faq from '@/components/static/Faq'
// const Terminos = () => import(/* webpackChunkName: "static" */ '@/components/static/Terminos')
import Terminos from '@/components/static/Terminos'
// const Privacidad = () => import(/* webpackChunkName: "static" */ '@/components/static/Privacidad')
import Privacidad from '@/components/static/Privacidad'
// const MisPedidos = () => import(/* webpackChunkName: "cliente" */ '@/components/User/MisPedidos')
import MisPedidos from '@/components/User/MisPedidos'
// const MenuPedido = () => import(/* webpackChunkName: "cliente" */ '@/components/Pedido/Menu')
import MenuPedido from '@/components/Pedido/Menu'
// const CheckoutAdmin = () => import(/* webpackChunkName: "cliente" */ '@/components/Pedido/CheckoutAdmin')
import CheckoutAdmin from '@/components/Pedido/CheckoutAdmin'
// const Checkout = () => import(/* webpackChunkName: "cliente" */ '@/components/Pedido/Checkout')
import Checkout from '@/components/Pedido/Checkout'
// const Partners = () => import(/* webpackChunkName: "static" */ '@/components/static/Partners')
import Partners from '@/components/static/Partners'
// const Platos = () => import(/* webpackChunkName: "resto" */ '@/components/Platos/Platos')
import Platos from '@/components/Platos/Platos'
// const PlatoForm = () => import(/* webpackChunkName: "resto" */ '@/components/Platos/PlatoForm')
import PlatoForm from '@/components/Platos/PlatoForm'
// const GestorEntregas = () => import(/* webpackChunkName: "resto" */ '@/components/Restaurante/GestorEntregas')
import GestorEntregas from '@/components/Restaurante/GestorEntregas'
import AdminGestorEntregas from '@/components/Restaurante/AdminGestorEntregas'

const AdminPedidos = () => import(/* webpackChunkName: "cliente" */ '@/components/User/AdminPedidos')
// import AdminPedidos from '@/components/User/AdminPedidos'
// const NewUser = () => import(/* webpackChunkName: "cliente" */ '@/components/User/NewUser')
import NewUser from '@/components/User/NewUser'
// const OnDemand = () => import(/* webpackChunkName: "static" */ '@/components/static/OnDemand')
import OnDemand from '@/components/static/OnDemand'
// const HistorialEmpresa = () => import(/* webpackChunkName: "cliente" */ '@/components/User/HistorialEmpresa')
import HistorialEmpresa from '@/components/User/HistorialEmpresa'
// const InvitarUsuarios = () => import(/* webpackChunkName: "cliente" */ '@/components/User/InvitarUsuarios')
import InvitarUsuarios from '@/components/User/InvitarUsuarios'
// const Usuarios = () => import(/* webpackChunkName: "cliente" */ '@/components/User/Usuarios')
import Usuarios from '@/components/User/Usuarios'
// const AsignarMenu = () => import(/* webpackChunkName: "resto" */ '@/components/Restaurante/AsignarMenu')
import AsignarMenu from '@/components/Restaurante/AsignarMenu'
// const HistoricoEntregas = () => import(/* webpackChunkName: "resto" */ '@/components/Restaurante/HistoricoEntregas')
import HistoricoEntregas from '@/components/Restaurante/HistoricoEntregas'
// const Proveedores = () => import(/* webpackChunkName: "admin" */ '@/components/Proveedores/Lista')
import Proveedores from '@/components/Proveedores/Lista'
// const ProveedoresForm = () => import(/* webpackChunkName: "admin" */ '@/components/Proveedores/Form')
import ProveedoresForm from '@/components/Proveedores/Form'
// const Clientes = () => import(/* webpackChunkName: "admin" */ '@/components/Clientes/ListaClientes')
import Clientes from '@/components/Clientes/ListaClientes'
// const ClientesForm = () => import(/* webpackChunkName: "admin" */ '@/components/Clientes/FormCliente')
import ClientesForm from '@/components/Clientes/FormCliente'
// const ListaCombos = () => import(/* webpackChunkName: "admin" */ '@/components/Combos/ListaCombos')
import ListaCombos from '@/components/Combos/ListaCombos'
// const FormCombo = () => import(/* webpackChunkName: "admin" */ '@/components/Combos/FormCombo')
import FormCombo from '@/components/Combos/FormCombo'
// const ListaLiquidacionesProveedor = () => import(/* webpackChunkName: "admin" */ '@/components/Liquidaciones/ListaProveedores')
import ListaLiquidacionesProveedor from '@/components/Liquidaciones/ListaProveedores'
// const FormLiquidacionesProveedores = () => import(/* webpackChunkName: "admin" */ '@/components/Liquidaciones/FormProveedores')
import FormLiquidacionesProveedores from '@/components/Liquidaciones/FormProveedores'
// const DetalleLiquidacionesProveedores = () => import(/* webpackChunkName: "admin" */ '@/components/Liquidaciones/DetalleLiquidacion')
import DetalleLiquidacionesProveedores from '@/components/Liquidaciones/DetalleLiquidacion'
// const FormPagoLiquidacionProveedor = () => import(/* webpackChunkName: "admin" */ '@/components/Liquidaciones/FormPago')
import FormPagoLiquidacionProveedor from '@/components/Liquidaciones/FormPago'
import Perfil from '@/components/User/Perfil'
import ListaLiquidacionesCliente from '@/components/Liquidaciones/ListaClientes'
import FormLiquidacionesClientes from '@/components/Liquidaciones/FormCliente'
import DetalleLiquidacionCliente from '@/components/Liquidaciones/DetalleLiquidacionCliente'
import RegistroInvitado from '@/components/User/RegistroInvitado'
import FormCobroLiquidacionCliente from '@/components/Liquidaciones/FormCobroCliente'
import Categorias from '@/components/Categorias/Lista'
import LiquidacionesUsuario from '@/components/User/Liquidaciones'
import DetalleLiquidacionUsuarioCliente from '@/components/User/DetalleLiquidacionCliente'
import LiquidacionesEnRestaurante from '@/components/Restaurante/Liquidaciones'
import DetalleLiquidacionRestaurante from '@/components/Restaurante/DetalleLiquidacion'
import EnConstruccion from '@/components/static/EnContstruccion.vue'
import Restablecer from '@/components/static/Restablecer'
import RepararPedidos from '@/components/Pedido/ReparadorPedidos'
import AdminRoot from '@/components/Pedido/AdminPedidosRoot'
import Stats from '@/components/Stats/Stats'
import Campaigns from '@/components/Campaigns/Campaigns'
import NewCampaign from '@/components/Campaigns/New'
import CampaignAnswer from '@/components/Campaigns/Answer'
import MeasureUnitList from '@/components/MeasureUnits/List'
import NotificationsList from '@/components/Notifications/List'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/adminpedidos',
      component: AdminPedidos
    },
    {
      path: '/admingestorentregas',
      component: AdminGestorEntregas
    },
    {
      path: '/adminroot',
      component: AdminRoot
    },
    {
      path: '/stats',
      component: Stats
    },
    {
      path: '/measureUnits',
      component: MeasureUnitList
    },
    {
      path: '/notifications',
      component: NotificationsList
    },
    {
      path: '/campaigns',
      component: Campaigns
    },
    {
      path: '/campaigns/new',
      component: NewCampaign
    },
    {
      path: '/campaigns/edit/:id',
      component: NewCampaign
    },
    {
      path: '/campaign/answer',
      component: CampaignAnswer
    },
    {
      path: '/asignarmenu',
      component: AsignarMenu
    },
    {
      path: '/categorias',
      component: Categorias
    },
    {
      path: '/checkout',
      component: Checkout
    },
    {
      path: '/checkoutadmin',
      component: CheckoutAdmin
    },
    {
      path: '/clientes',
      component: Clientes
    },
    {
      path: '/clienteform',
      component: ClientesForm
    },
    {
      path: '/clienteform/edit/:id',
      component: ClientesForm
    },
    {
      path: '/contacto',
      component: Contacto
    },
    {
      path: '/combos',
      component: ListaCombos
    },
    {
      path: '/comboform',
      component: FormCombo
    },
    {
      path: '/comboform/edit/:id',
      component: FormCombo
    },
    {
      path: '/enconstruccion',
      component: EnConstruccion
    },
    {
      path: '/faq',
      component: Faq
    },
    {
      path: '/gestorentregas',
      component: GestorEntregas
    },
    {
      path: '/hacerpedido',
      component: MenuPedido,
      props: true
    },
    {
      path: '/historicoentregas',
      component: HistoricoEntregas
    },
    {
      path: '/historialempresa',
      component: HistorialEmpresa
    },
    {
      path: '/invitarusuarios',
      component: InvitarUsuarios
    },
    {
      path: '/liquidaciones/clientes',
      component: ListaLiquidacionesCliente
    },
    {
      path: '/liquidaciones/proveedores',
      component: ListaLiquidacionesProveedor
    },
    {
      path: '/liquidaciones/clientes/form/:id',
      component: FormLiquidacionesClientes
    },
    {
      path: '/liquidaciones/proveedores/form/:id',
      component: FormLiquidacionesProveedores
    },
    {
      path: '/liquidaciones/clientes/detalle/:id',
      component: DetalleLiquidacionCliente
    },
    {
      path: '/liquidaciones/clientes/cobro/:id',
      component: FormCobroLiquidacionCliente
    },
    {
      path: '/liquidaciones/proveedores/detalle/:id',
      component: DetalleLiquidacionesProveedores
    },
    {
      path: '/liquidaciones/proveedores/pago/:id',
      component: FormPagoLiquidacionProveedor
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/logout',
      component: Logout
    },
    {
      path: '/mispedidos',
      component: MisPedidos
    },
    {
      path: '/newuser',
      component: NewUser
    },
    {
      path: '/newuser/:sucursal',
      component: NewUser
    },
    {
      path: '/ondemand',
      component: OnDemand
    },
    {
      path: '/partners',
      component: Partners
    },
    {
      path: '/perfil',
      component: Perfil
    },
    {
      path: '/platoform',
      name: 'PlatoForm',
      component: PlatoForm
    },
    {
      path: '/platoform/edit/:id',
      name: 'PlatoFormEdit',
      component: PlatoForm
    },
    {
      path: '/platos',
      name: 'Platos',
      component: Platos
    },
    {
      path: '/privacidad',
      component: Privacidad
    },
    {
      path: '/proveedores',
      name: 'Proveedores',
      component: Proveedores
    },
    {
      path: '/proveedoresform',
      name: 'ProveedoresForm',
      component: ProveedoresForm
    },
    {
      path: '/proveedoresform/edit/:id',
      name: 'ProveedoresFormEdit',
      component: ProveedoresForm
    },
    {
      path: '/recuperar',
      component: Recuperar
    },
    {
      path: '/recuperar/:token',
      component: Restablecer
    },
    {
      path: '/registro',
      component: Registro
    },
    {
      path: '/repararpedidos',
      component: RepararPedidos
    },
    {
      path: '/restaurante/liquidaciones',
      component: LiquidacionesEnRestaurante
    },
    {
      path: '/restaurante/liquidaciones/:id',
      component: DetalleLiquidacionRestaurante
    },
    {
      path: '/suscripcion',
      name: 'Suscripcion',
      component: Suscripcion
    },
    {
      path: '/terminos',
      component: Terminos
    },
    {
      path: '/usuarios/sucursal/:sucursal',
      component: Usuarios
    },
    {
      path: '/usuarios',
      component: Usuarios
    },
    {
      path: '/usuarios/invitado/:id',
      component: RegistroInvitado
    },
    {
      path: '/usuarios/liquidaciones',
      component: LiquidacionesUsuario
    },
    {
      path: '/usuarios/liquidaciones/:id',
      component: DetalleLiquidacionUsuarioCliente
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js